//#region src/utils/platform.ts
/**
* Gets the platform on which the application is running.
* If the userAgent could not be determined, this will default to "other"
*/
function getPlatform() {
	const userAgent = globalThis.navigator?.userAgent;
	if (/android/i.test(userAgent)) return "android";
	else if (/iPad|iPhone|iPod|Mac/.test(userAgent) && "ontouchend" in document) return "ios";
	else return "other";
}
//#endregion
export { getPlatform };

//# sourceMappingURL=platform.js.map